<template>
  <div class="flex flex-col gap-2 xl:flex-row">
    <ViewAndEdit
      v-model="selectedPropertyString"
      label="Property"
      mode="edit"
      :attributes="{ type: 'select', options: propertyOptions }"
      @update:model-value="onPropertyChange"
    />
    <ConditionOperator
      v-if="currentConditionDefinition"
      :index="index"
      :condition-definition="currentConditionDefinition"
      :selected-property="selectedPropertyString"
      :expression-condition="expressionCondition"
    />
    <div class="xl:self-end">
      <WorkflowIcon icon-class="self-end" icon-type="trash" tooltip="Delete" @click-icon="removeCondition" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ViewAndEdit from '../common/ViewAndEdit.vue';
import type { WorkflowExpressionCondition } from '@/api/entity_types/workflow/WorkflowCondition';
import ConditionOperator from './ConditionOperator.vue';
import { useConditionItem } from './useConditionItem';
import WorkflowIcon from '../common/WorkflowIcon.vue';

export type ConditionItemProps = {
  expressionCondition: WorkflowExpressionCondition;
  index: number;
};
const props = defineProps<ConditionItemProps>();

const { selectedPropertyString, propertyOptions, currentConditionDefinition, onPropertyChange, removeCondition } =
  useConditionItem(props);
</script>
